import React from 'react';
import {useTranslation} from 'react-i18next';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';

import PaiementHorsZone from 'components/Paiement/PaiementHorsZone';

const NoAccessError = ({errorCode}) => {
  const {t} = useTranslation();
  switch (errorCode) {
    case 'notLocal':
      return <PaiementHorsZone />;
    case 'full':
      return (
        <Dialog open className="my-dialog">
          <DialogContent>
            <DialogContentText>
              {t('la-seance-est-complete')}
              <br />
              {t('merci-dessayer-plus-tard')}
            </DialogContentText>
          </DialogContent>
        </Dialog>
      );
    case 'already':
      return (
        <Dialog open className="my-dialog">
          <DialogContent>
            <DialogContentText>{t('utilisateur-connecte-avec-un-autre-appareil')}</DialogContentText>
          </DialogContent>
        </Dialog>
      );
    case 'lien privé invalide':
    case 'noSeance':
      return (
        <Dialog open className="my-dialog">
          <DialogContent>
            <DialogContentText>{t('cette-page-nexiste-pas')}</DialogContentText>
          </DialogContent>
        </Dialog>
      );
    case 'otherTab':
      return (
        <Dialog open className="my-dialog">
          <DialogContent>
            <DialogContentText>{t('page-ouverte-dans-un-autre-onglet')}</DialogContentText>
          </DialogContent>
        </Dialog>
      );
    default: {
      console.warn('new error', errorCode);
      return null;
    }
  }
};

export default NoAccessError;
